<template>
    <div class="living-options-properties">
      <div class="row">
        <div class="col-12">
          <div class="properties">
            <h3>Properties</h3>
            <button class="btn btn-sm btn-primary mb-4" @click="addProperty">Add Property</button>
            <div class="row mb-4">

              <div class="col-6">
                <div class="status-option">
                  <input type="checkbox" id="available" value="Available" v-model="filterStatuses">
                  <label class="status-option__label" for="available">Available</label>
                </div>

                <div class="status-option">
                  <input type="checkbox" id="builder-lots" value="Builder Lots" v-model="filterStatuses">
                  <label class="status-option__label" for="builder-lots">Builder Lots</label>
                </div>

                <div class="status-option">
                  <input type="checkbox" id="coming-soon" value="Coming Soon" v-model="filterStatuses">
                  <label class="status-option__label" for="coming-soon">Coming Soon</label>
                </div>

                <div class="status-option">
                  <input type="checkbox" id="on-hold" value="On Hold" v-model="filterStatuses">
                  <label class="status-option__label" for="on-hold">On Hold</label>
                </div>

                <div class="status-option">
                  <input type="checkbox" id="sold" value="Sold" v-model="filterStatuses">
                  <label class="status-option__label" for="sold">Sold</label>
                </div>

                <div class="status-option">
                  <input type="checkbox" id="not-released" value="Not Released" v-model="filterStatuses">
                  <label class="status-option__label" for="not-released">Not Released</label>
                </div>

                <div class="status-option">
                  <input type="checkbox" id="unassigned" value="Unassigned" v-model="filterStatuses">
                  <label class="status-option__label" for="unassigned">Unassigned</label>
                </div>
              </div>

              <div class="col-6">
                <div class="status-option">
                  <input type="checkbox" id="active" value="Active" v-model="filterActiveStates">
                  <label class="status-option__label" for="active">Active</label>
                </div>

                <div class="status-option">
                  <input type="checkbox" id="inactive" value="Inactive" v-model="filterActiveStates">
                  <label class="status-option__label" for="inactive">Inactive</label>
                </div>
              </div>

            </div>
            <div class="mb-2">
              <input class="form-control" type="text" v-model="propertiesFilterText" placeholder="Filter properties">
            </div>
            <v-table
              :columns="[
                { label: 'Label', field: 'label'},
                { 
                  label: 'Status',
                  field: 'status',
                  options: {
                    sortable: true,
                    callback: function(row) {
                      filterByStatus(row)
                    },
                    return: function (fieldValue) {
                      if (fieldValue === 'Not Found') {
                        return '-'
                      } else {
                        switch (fieldValue) {
                          case 'Available':
                            return `<div class='status status--available'>${fieldValue}</div>`
                            
                          case 'Coming Soon':
                            return `<div class='status status--coming-soon'>${fieldValue}</div>`

                          case 'On Hold':
                            return `<div class='status status--hold'>${fieldValue}</div>`

                          case 'Sold':
                            return `<div class='status status--sold'>${fieldValue}</div>`

                          case 'Builder Lots':
                            return `<div class='status status--builder-lots'>${fieldValue}</div>`

                          case 'Not Released':
                            return `<div class='status status--not-released'>${fieldValue}</div>`
                        
                          default:
                            return fieldValue
                        }
                      }
                    },
                  }
                },
                {
                  label: 'Price',
                  field: 'price',
                  options: {
                    sortable: true,
                    return: function (fieldValue) {
                      if (fieldValue === 'Not Found' || !fieldValue) {
                        return '-'
                      } else {
                        return fieldValue.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 })
                      }
                    },
                  }
                },

                { 
                  label: 'Subsection',
                  field: 'subsection.label',
                  options: {
                    sortable: true,
                    callback: function(row) {
                      navToSubsection(row)
                    },
                    return: function (fieldValue) {
                      if (fieldValue === 'Not Found') {
                        return '-'
                      } else {
                        return fieldValue
                      }
                    },
                  }
                },
                { 
                  label: 'Living Option',
                  field: 'livingOption.label',
                  options: {
                    sortable: true,
                    callback: function(row) {
                      navToLivingOption(row)
                    },
                    return: function (fieldValue) {
                      if (fieldValue === 'Not Found') {
                        return '-'
                      } else {
                        return fieldValue
                      }
                    },
                  }
                },
                {
                  label: 'Dwelling',
                  field: 'dwelling.label',
                  options: {
                    sortable: true,
                    callback: function(row) {
                      navToDwelling(row)
                    },
                    return: function (fieldValue) {
                      if (fieldValue === 'Not Found') {
                        return '-'
                      } else {
                        return fieldValue
                      }
                    },
                  }
                },
              ]"
              :rows="filteredProperties"
              :show-active-toggle="activeUser.access.indexOf('live-toggle') !== -1"
              save-action="SAVE_PROPERTY"
              @edit="editProperty($event._id)"
              @clone="cloneProperty($event)"
              @delete="deleteProperty($event._id)"
            />
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VTable from '@/components/VTable'

export default {
  components: {
    VTable
  },

  data () {
    return {
      propertiesFilterText: '',
      filterStatuses: [],
      filterActiveStates: [],
    }
  },

  computed: {
    ...mapGetters([
      'properties'
    ]),

    activeUser () {
      return this.$store.getters.user
    },

    filteredProperties () {
      let filtered = this.properties.filter(property => property.label.toLowerCase().includes(this.propertiesFilterText.toLowerCase()))

      if (this.filterStatuses.length) {
        filtered = filtered.filter(property => this.filterStatuses.includes(property.status))
      }

      if (this.filterActiveStates.length) {
        filtered = filtered.filter(property => (this.filterActiveStates.includes('Active') && property.active) || (this.filterActiveStates.includes('Inactive') && !property.active))
      }

      return filtered
    },   
  },

  created () {
    this.$store.dispatch('FETCH_PROPERTIES')
  },

  methods: {
    filterByStatus (row) {
      this.filterStatuses = []
      this.filterStatuses.push(row.status)
    },

    navToSubsection (row) {
      this.$router.push(`/live/subsections/${row.subsectionId}`)
    },

    navToLivingOption (row) {
      if (row.livingOptionId) {
        this.$router.push(`/live/masterplan/${row.livingOptionId}`)
      }
    },

    navToDwelling (row) {
      if (row.dwellingId) {
        this.$router.push(`/live/dwellings/${row.dwellingId}`)
      }
    },

    async addProperty () {
      const newProperty = await this.$store.dispatch('ADD_NEW_PROPERTY')
      this.$store.dispatch('SAVE_PROPERTY', newProperty)
      this.editProperty(newProperty._id)
    },

    async cloneProperty (property) {
      const clonedProperty = await this.$store.dispatch('CLONE_PROPERTY', property)
      this.$store.dispatch('SAVE_PROPERTY', clonedProperty)
    },

    deleteProperty (id) {
      if (confirm('Are you sure?')) {
        this.$store.dispatch('DELETE_PROPERTY', id)
      }
    },

    editProperty (id) {
      this.$router.push(`/live/properties/${id}`)
    }
  },
}
</script>
